<template>
    <div v-if="hasModules">
        <h2 class="content-title" v-if="title">{{ title }}</h2>
        <section class="dashboard-list">
            <div class="row">
                <template v-for="(module, index) in modules">
                    <template v-if="module.route">
                        <router-link
                            :class="moduleClass"
                            :key="index"
                            :to="{ name: module.route, params: { appCode: formatRouteAppCode(module.code) } }">

                            <dashboard-item
                                :module="module"
                                :config="dashboardConf"
                                :showImage="showImage"
                                :showIcon="showIcon"
                                :showNotifications="showNotifications"
                                :showNotificationsIcon="showNotificationsIcon"
                                :showNotificationsArrow="showNotificationsArrow"/>

                            </router-link>
                        </template>
                        <template v-else-if="module.url">
                            <a
                                :class="moduleClass"
                                :key="index"
                                :href="module.url"
                                target="_blank">

                                <dashboard-item
                                    :module="module"
                                    :config="dashboardConf"
                                    :showImage="showImage"
                                    :showIcon="showIcon"
                                    :showNotifications="showNotifications"
                                    :showNotificationsIcon="showNotificationsIcon"
                                    :showNotificationsArrow="showNotificationsArrow"/>
                            </a>
                        </template>
                        <template v-else>
                            <dashboard-item
                                :key="index"
                                :listClass="moduleClass"
                                :module="module"
                                :config="dashboardConf"
                                :showImage="showImage"
                                :showIcon="showIcon"
                                :showNotifications="showNotifications"
                                :showNotificationsIcon="showNotificationsIcon"
                                :showNotificationsArrow="showNotificationsArrow"/>
                        </template>
                </template>
            </div>
            <div class="d-flex justify-content-end" v-if="showButtonMore">
                <div class="btn btn-main btn-md btn-responsive mx-0 my-3 my-sm-0" @click.prevent="showMore">ver mais</div>
            </div>
        </section>
    </div>
</template>
<script>
import mixin from '../../mixin';
import mixinTheme from '@/app/shared/mixins/theme';
import { formatRouteAppCode } from '@config/utils';
import DashboardItem from './DashboardItem';
import { CheckPermission } from '../../../../app/shared/mixins/acls';

export default {
    mixins: [
        mixin,
        mixinTheme,
        CheckPermission,
    ],
    components: {
        DashboardItem,
    },
    props: {
        title: {
            type: String,
            default: null,
        },
        showCurrentModule: {
            type: Boolean,
            default: false,
        },
        listBackoffice: {
            type: Boolean,
            default: true,
        },
        listInactive: {
            type: Boolean,
            default: false,
        },
        limit: {
            type: Number,
            default: undefined,
        },
        listClass: {
            type: String,
            default: 'col-sm-6',
        },
        showImage: {
            type: Boolean,
            default: true,
        },
        showIcon: {
            type: Boolean,
            default: true,
        },
        showNotifications: {
            type: Boolean,
            default: true,
        },
        showNotificationsIcon: {
            type: Boolean,
            default: true,
        },
        showNotificationsArrow: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            storageKey: 'portal:dashboard',
            isDemo: false,
            notifications: [],
            showAll: false,
        }
    },
    mounted() {
        let obj = window.sessionStorage.getItem(this.storageKey);
        if(obj) {
            obj = JSON.parse(obj || {});
            this.showAll = !!obj.showAllItems;
        }
    },
    // beforeDestroy() {
    //     window.sessionStorage.removeItem(this.storageKey);
    // },
    computed: {
        allModules() {
            return this.$store.getters.getModules(this.moduleCode) || [];
        },
        filteredModules() {
            let allModules = JSON.parse(JSON.stringify(this.allModules));
            let items = allModules.filter(m => {
                if(!this.isDemo){
                    if(!this.listInactive && !m.active) return false;

                    if(!this.listBackoffice && m.backoffice) return false;
                }
                if(!this.showCurrentModule && this.isCurrentRoute(m.route)) return false;

                return !m.acl || this.checkPermission(m, 'acl');
            });

            items.map(m => {
                // m.notifications = {};
                if(this.enableNotifications && this.$auth.check()){
                    // DUMMY NUMBER
                    let num = m.active && !m.backoffice ? Math.floor(Math.random() * (100 - 0 + 1) + 0) : 0;
                    m.notifications.num = num;
                    m.notifications.text = this.processNotification(m.notifications.num);
                }
            });
            return items;
        },
        modules() {
            if(!this.showAll && this.limit > 0) {
                return this.filteredModules.slice(0, this.limit);
            }
            return this.filteredModules;
        },
        hasModules() {
            return this.modules.length > 0;
        },
        currentRouteName() {
            return this.$route.name;
        },
        showButtonMore() {
            return !this.showAll && this.limit > 0 && this.filteredModules.length > this.limit;
        },
        moduleClass() {
            return ['dashboard-module', this.listClass].join(' ');
        },
        storageObject() {
            return {
                showAllItems: this.showAll,
            };
        },
    },
    methods: {
        formatRouteAppCode(code) {
            return formatRouteAppCode(code);
        },
        isCurrentRoute: function(route) {
            return route ? route.split(".")[0].toLowerCase() == this.currentRouteName.split(".")[0].toLowerCase() : false;
        },
        showMore: function() {
            this.showAll = true;
            window.sessionStorage.setItem(this.storageKey, JSON.stringify(this.storageObject));
        },
    }
}
</script>